import Fragment from 'ynf-core-engine/Fragment'
import { getUrlParams, getBillNoByPath } from "./util"

export default function mobileInit () {
  // h5和小程序上空白页跳转都会使用openYnfBill
  // h5下的格式是正常的: https://xxxxx/mdf-node/fragment/xxxxx?参数
  // 小程序下的格式是: file:///xxxxx/index.html?参数#/fragment/xxx
  window.openYnfBill = function (url, params, type) {
    const urlParams = new URL(url);
    const query = getUrlParams(urlParams.href)
    const billNo = getBillNoByPath(urlParams.href)
    window.ReactDOM.render(
      <Fragment query={query} billNo={billNo}/>,
      document.getElementById('container')
    )
  }
  window.closeYnfBill = function (history, type) {
    const container = document.getElementById('container')
    container && window.ReactDOM.unmountComponentAtNode(container);
  }

  window.mtl?.execUpesnBridge?.({
    method: 'ynfIsLoad',
    params1: '',
    params2: '',
    success: function (res) {
      console.log('ynfIsLoad execUpesnBridge success callback execute')
    },
    fail: function (err) {
      console.log('ynfIsLoad execUpesnBridge fail callback execute, error message is', err)
    }
  });
}